<template>
  <div class="webdatalist">
    <f7-list media-list accordion class="searchbar-found" id="bank-list">
      <div class="showSmallScreenOnly">
        <f7-list media-list>
          <f7-list-item v-for="account in bankAccounts" :key="account.id">
            <b-row>
              <b-col cols="7" @click="openFormListStatement(account)">
                <div class="item-title">
                  {{ account.name }}
                </div>
                <div class="item-subtitle fs-13px">
                  <div class="fs-13px" v-for="accountData in formatIban(account.iban, account.zoneCode)" :key="accountData.id">
                    {{ $t(accountData.labelId) }} : ****{{ sliceIBAN(accountData.hiddenValue, 4) }}
                  </div>
                </div>
              </b-col>
              <b-col class="d-flex justify-content-end">
                <b-button
                  class="btn btn-icon"
                  :title="$t('common.default')"
                  @click="setDefaultBanqueAccount(account, $event)">
                  <f7-icon :fa="account.isDefault === '1' ? 'star' : 'star-o'" class="fa-2x color-icon" size="17px"></f7-icon>
                </b-button>
                <b-button
                  :style="[$engine.rights.rightIs('bank_account_editer', false) ? {'opacity':'50%'} : {}]"
                  :title="$t('common.negot')"
                  @click="modifyBanqueAccount(account, $event)">
                  <i class="fa-light fa-pencil color-icon"></i>
                </b-button>
                <b-button
                  class="btn btn-icon btn-icon-red"
                  :style="[$engine.rights.rightIs('bank_account_supprimer', false) ? {'opacity':'50%'} : {}]"
                  :title="$t('common.rm_label')"
                  @click="removeBankAccount(account.id, $event)">
                  <!-- <i class="fa fa-times-circle button-delete" style="margin-bottom: 0.5%; color: red;"></i> -->
                  <i class="fa-light fa-trash"
                    :style="[$engine.rights.rightIs('bank_account_supprimer', false) ? {'color':'grey'} : {}]">
                  </i>
                </b-button>
              </b-col>
            </b-row>
            <!-- Removing Swipeout actions -->
            <!-- <f7-swipeout-actions right>
              <f7-swipeout-button color="yellow">
                  <i class="icon fa" :class="account.isDefault === '1' ? 'fa-star' : 'fa-star-o'"></i>
              </f7-swipeout-button>
              <f7-swipeout-button color="green">
                  <i class="icon fa fa-pencil"></i>
              </f7-swipeout-button>
              <f7-swipeout-button color="red">
                  <i class="icon fa fa-trash"></i>
              </f7-swipeout-button>
            </f7-swipeout-actions> -->
          </f7-list-item>
        </f7-list>
      </div>

      <div class="showLargeScreenOnly">
        <ul v-if="bankAccounts.length > 0">
          <li v-for="account in bankAccounts" :key="account.id" class="bankAccountList">
            <div class="item-content boxRequest" @click="openFormListStatement(account)">
              <div class="item-media">
                <i class="fa-light fa-credit-card p-4" size="17px"></i>
              </div>
              <div class="item-inner">
                <div class="item-title">
                  {{ account.name }}
                </div>
              </div>
              <div class="item-subtitle bankIban fs-13px" :class="{bankIbanLarge: SmallOnLargeScreen}">
                <div v-for="accountData in formatIban(account.iban, account.zoneCode)">
                  {{ $t(accountData.labelId) }} : {{ accountData.hiddenValue }}
                </div>
              </div>
              <!-- <div class="item-after defaultLabel" :class="{defaultLabelLarge: SmallOnLargeScreen}">{{ isDefaultLabel(account.isDefault) }}</div> -->
              <div class="item-media button-swipe-out mr-30px">
                <b-button
                  :title="$t('common.default')"
                  @click="setDefaultBanqueAccount(account, $event)">
                  <f7-icon :fa="account.isDefault === '1' ? 'star' : 'star-o'" class="fa-2x color-icon" size="17px"></f7-icon>
                </b-button>
                <b-button
                  :style="[$engine.rights.rightIs('bank_account_editer', false) ? {'opacity':'50%'} : {}]"
                  :title="$t('common.negot')"
                  @click="modifyBanqueAccount(account, $event)">
                  <i class="fa-light fa-pencil color-icon"></i>
                </b-button>
                <b-button
                  class="btn-icon-red"
                  :style="[$engine.rights.rightIs('bank_account_supprimer', false) ? {'opacity':'50%'} : {}]"
                  :title="$t('common.rm_label')"
                  @click="removeBankAccount(account.id, $event)">
                  <!-- <i class="fa fa-times-circle button-delete" style="margin-bottom: 0.5%; color: red;"></i> -->
                  <i class="fa-light fa-trash"
                    :style="[$engine.rights.rightIs('bank_account_supprimer', false) ? {'color':'grey'} : {}]">
                  </i>
                </b-button>
              </div>
            </div>
          </li>
        </ul>
        <div v-else class="noResult">{{ $t('common.no_result') }}</div>
      </div>
    </f7-list>
  </div>
</template>

<script>
import {errorMessageAlert} from '@/helpers/alert'
import {extractForeignIban} from '@/helpers/format'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'BankAccountList',
  props: ['bankAccounts', 'filterBy', 'SmallOnLargeScreen'],
  data () {
    return {
      extractedBankData: {}
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    accountData (account) {
      return this.formatIban(account.iban, account.zoneCode)
    },
    displayOnVoid (val) {
      if (val == null || val === '') {
        return 'Empty'
      } else {
        return val
      }
    },
    formatIban (iban, zone) {
      return extractForeignIban(iban, zone)
    },
    generateQRCode (accountId, e) {
      console.log(accountId)
      e.stopPropagation()
      this.$bus.$emit('popup-bank-account-qr-code', accountId)
    },
    isDefaultLabel (isDefault) {
      if (isDefault === '1') {
        return this.$i18n.t('bank_accounts.default_act_label')
      } else {
        return ''
      }
    },
    modifyBanqueAccount (account, e) {
      e.stopPropagation()
      if (this.$engine.rights.rightIs('bank_account_editer', false)) {
        return
      }
      this.$bus.emit('edit-bank-account', account)
      // this.$f7.popup('#EditBankAccount')
      this.$engine.settings.set({modifyAccount: account})
      loadPage(this, {url: '/bankAccounts/modify/'})
    },
    openFormListStatement (account) {
      this.$engine.bankAccounts.getOperationStatements(account.iban).then(response => {
        if (response.status === 200) {
          let bankAccounts = this.$engine.bankAccounts.get()
          for (var i in bankAccounts) {
            if (bankAccounts[i].iban === response.data.iban) {
              bankAccounts[i].balances = response.data.receivedTransfers
            }
          }
          this.$engine.bankAccounts.set(bankAccounts)
        }
      })
      this.$engine.bankAccounts.setIbanStatment(account.iban)
      this.$bus.emit('refresh-bank-accounts-list-statement')
      loadPage(this, {url: '/bankAccounts/listStatement/'})
    },
    removeBankAccount (id, e) {
      e.stopPropagation()
      let that = this
      this.$f7.modal({
        title: this.$i18n.t('common.oper_confirm'),
        text: this.$i18n.t('bank_accounts.delete_act_confirmation'),
        buttons: [{
          text: this.$t('common.cncl'),
          onClick: this.$f7.closeModal()
        }, {
          text: 'OK',
          onClick: function () {
            that.$engine.bankAccounts
              .del(id)
              .then(() => {
                that.$f7.modal({
                  title: that.$i18n.t('bank_accounts.deleted_act'),
                  text: '<span class="preloader"></span>'
                })
                setTimeout(function () {
                  that.bankAccounts = that.bankAccounts.filter(function (value, index, arr) { return value.id !== id })
                  that.$f7.closeModal()
                  loadPage(that, {url: '/bankAccounts/', force: false, ignoreCache: false})
                }, 2000)
              })
              .catch(err => {
                that.handleError(err) // mixins errorHandlerMixins
              })
          }
        }]
      })
    },
    setDefaultBanqueAccount (account, e) {
      e.stopPropagation()
      let that = this
      let isDefaultValue = ''
      if (account.isDefault === '0') {
        isDefaultValue = '1'
      } else if (account.isDefault === '1') {
        isDefaultValue = '0'
      }
      this.$engine.bankAccounts
        .update({
          id: account.id,
          name: account.name,
          iban: account.iban,
          qxban: '',
          isDefault: isDefaultValue,
          zoneCode: account.zoneCode
        })
        .then(() => {
          that.$f7.modal({
            title: that.$i18n.t('bank_accounts.default_act_setted'),
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
            that.name = ''
            that.iban = ''
            that.id = 0
            that.$bus.$emit('refresh-bank-accounts')
          }, 2000)
        })
        .catch(err => {
          errorMessageAlert(err, that)
        })
    },
    sliceIBAN (str, nb) {
      return str.toString().slice(str.length - nb)
    }
  }
}
</script>

<style scoped>
@media (min-width: 1200px) {
  .item-inner {
    display: flex !important;
  }
}
</style>
